import { NisModal } from "../NisModal";
export class FormModal extends NisModal {
    constructor(options = {}) {
        super(options);
        this.options = options;
        this.resolver = null;
        this.hidden.on(() => this.cancel());
    }
    confirm(value) {
        if (this.resolver && !this.resolver.resolved) {
            this.resolver.resolved = true;
            this.resolver.handler(value);
        }
        this.remove();
    }
    getValueForCancel() {
        return null;
    }
    cancel() {
        this.confirm(this.getValueForCancel());
    }
    do() {
        return new Promise(resolve => {
            this.resolver = {
                handler: resolve,
                resolved: false
            };
            this.show();
        });
    }
}
